/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateTestTermRequestDto } from '../models';
// @ts-ignore
import type { ExtendTestTermTimeRequestDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { RevealTestTermAnswersResponseDto } from '../models';
// @ts-ignore
import type { TestTermDetailDto } from '../models';
// @ts-ignore
import type { TestTermListResponseDto } from '../models';
// @ts-ignore
import type { UpdateTestTermRequestDto } from '../models';
/**
 * TestTermApi - axios parameter creator
 * @export
 */
export const TestTermApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new test term within a certification stage of type TEST. Initial status is NEW. 
         * @summary Create a new test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {CreateTestTermRequestDto} createTestTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestTerm: async (certificationId: number, stageId: number, createTestTermRequestDto: CreateTestTermRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('createTestTerm', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('createTestTerm', 'stageId', stageId)
            // verify required parameter 'createTestTermRequestDto' is not null or undefined
            assertParamExists('createTestTerm', 'createTestTermRequestDto', createTestTermRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestTermRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extends the end datetime of an active test term by the specified number of minutes. Validation: term must be IN_PROGRESS, must have endDatetime set, and extensionMinutes must not exceed timeExtensionMinutes from test stage config. 
         * @summary Extend test term end time
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {ExtendTestTermTimeRequestDto} extendTestTermTimeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendTestTermTime: async (certificationId: number, stageId: number, termId: number, extendTestTermTimeRequestDto: ExtendTestTermTimeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('extendTestTermTime', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('extendTestTermTime', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('extendTestTermTime', 'termId', termId)
            // verify required parameter 'extendTestTermTimeRequestDto' is not null or undefined
            assertParamExists('extendTestTermTime', 'extendTestTermTimeRequestDto', extendTestTermTimeRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/extend-time`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendTestTermTimeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get test term detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermDetail: async (certificationId: number, stageId: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestTermDetail', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestTermDetail', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestTermDetail', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all test terms for the specified certification stage (type TEST). 
         * @summary List test terms for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTerms: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestTerms', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestTerms', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks the term as having results revealed to participants. After this call, candidates see the full test results (for RESULT_WITH_QUESTIONS visibility: questions with correct answers, optionally for a configured window of minutes). Requires the term to be in COMPLETED status. 
         * @summary Reveal answers/results to participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealTestTermAnswers: async (certificationId: number, stageId: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('revealTestTermAnswers', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('revealTestTermAnswers', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('revealTestTermAnswers', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/reveal-answers`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates test term properties. All fields are optional. Status transitions: NEW -> IN_PROGRESS -> COMPLETED / CANCELLED, CANCELLED -> NEW. Reverting from CANCELLED to NEW does NOT re-add participants that were expired during the cancellation — the admin must re-assign them. 
         * @summary Update test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {UpdateTestTermRequestDto} updateTestTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestTerm: async (certificationId: number, stageId: number, termId: number, updateTestTermRequestDto: UpdateTestTermRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateTestTerm', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('updateTestTerm', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('updateTestTerm', 'termId', termId)
            // verify required parameter 'updateTestTermRequestDto' is not null or undefined
            assertParamExists('updateTestTerm', 'updateTestTermRequestDto', updateTestTermRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTestTermRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestTermApi - functional programming interface
 * @export
 */
export const TestTermApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestTermApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new test term within a certification stage of type TEST. Initial status is NEW. 
         * @summary Create a new test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {CreateTestTermRequestDto} createTestTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestTerm(certificationId: number, stageId: number, createTestTermRequestDto: CreateTestTermRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestTerm(certificationId, stageId, createTestTermRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermApi.createTestTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extends the end datetime of an active test term by the specified number of minutes. Validation: term must be IN_PROGRESS, must have endDatetime set, and extensionMinutes must not exceed timeExtensionMinutes from test stage config. 
         * @summary Extend test term end time
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {ExtendTestTermTimeRequestDto} extendTestTermTimeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendTestTermTime(certificationId: number, stageId: number, termId: number, extendTestTermTimeRequestDto: ExtendTestTermTimeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendTestTermTime(certificationId, stageId, termId, extendTestTermTimeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermApi.extendTestTermTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get test term detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestTermDetail(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestTermDetail(certificationId, stageId, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermApi.getTestTermDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all test terms for the specified certification stage (type TEST). 
         * @summary List test terms for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestTerms(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestTerms(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermApi.getTestTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks the term as having results revealed to participants. After this call, candidates see the full test results (for RESULT_WITH_QUESTIONS visibility: questions with correct answers, optionally for a configured window of minutes). Requires the term to be in COMPLETED status. 
         * @summary Reveal answers/results to participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revealTestTermAnswers(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevealTestTermAnswersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revealTestTermAnswers(certificationId, stageId, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermApi.revealTestTermAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates test term properties. All fields are optional. Status transitions: NEW -> IN_PROGRESS -> COMPLETED / CANCELLED, CANCELLED -> NEW. Reverting from CANCELLED to NEW does NOT re-add participants that were expired during the cancellation — the admin must re-assign them. 
         * @summary Update test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {UpdateTestTermRequestDto} updateTestTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTestTerm(certificationId: number, stageId: number, termId: number, updateTestTermRequestDto: UpdateTestTermRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTestTerm(certificationId, stageId, termId, updateTestTermRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermApi.updateTestTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestTermApi - factory interface
 * @export
 */
export const TestTermApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestTermApiFp(configuration)
    return {
        /**
         * Creates a new test term within a certification stage of type TEST. Initial status is NEW. 
         * @summary Create a new test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {CreateTestTermRequestDto} createTestTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestTerm(certificationId: number, stageId: number, createTestTermRequestDto: CreateTestTermRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto> {
            return localVarFp.createTestTerm(certificationId, stageId, createTestTermRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Extends the end datetime of an active test term by the specified number of minutes. Validation: term must be IN_PROGRESS, must have endDatetime set, and extensionMinutes must not exceed timeExtensionMinutes from test stage config. 
         * @summary Extend test term end time
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {ExtendTestTermTimeRequestDto} extendTestTermTimeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendTestTermTime(certificationId: number, stageId: number, termId: number, extendTestTermTimeRequestDto: ExtendTestTermTimeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto> {
            return localVarFp.extendTestTermTime(certificationId, stageId, termId, extendTestTermTimeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get test term detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermDetail(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto> {
            return localVarFp.getTestTermDetail(certificationId, stageId, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all test terms for the specified certification stage (type TEST). 
         * @summary List test terms for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTerms(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestTermListResponseDto> {
            return localVarFp.getTestTerms(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks the term as having results revealed to participants. After this call, candidates see the full test results (for RESULT_WITH_QUESTIONS visibility: questions with correct answers, optionally for a configured window of minutes). Requires the term to be in COMPLETED status. 
         * @summary Reveal answers/results to participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealTestTermAnswers(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<RevealTestTermAnswersResponseDto> {
            return localVarFp.revealTestTermAnswers(certificationId, stageId, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates test term properties. All fields are optional. Status transitions: NEW -> IN_PROGRESS -> COMPLETED / CANCELLED, CANCELLED -> NEW. Reverting from CANCELLED to NEW does NOT re-add participants that were expired during the cancellation — the admin must re-assign them. 
         * @summary Update test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {UpdateTestTermRequestDto} updateTestTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestTerm(certificationId: number, stageId: number, termId: number, updateTestTermRequestDto: UpdateTestTermRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto> {
            return localVarFp.updateTestTerm(certificationId, stageId, termId, updateTestTermRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestTermApi - interface
 * @export
 * @interface TestTermApi
 */
export interface TestTermApiInterface {
    /**
     * Creates a new test term within a certification stage of type TEST. Initial status is NEW. 
     * @summary Create a new test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {CreateTestTermRequestDto} createTestTermRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApiInterface
     */
    createTestTerm(certificationId: number, stageId: number, createTestTermRequestDto: CreateTestTermRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto>;

    /**
     * Extends the end datetime of an active test term by the specified number of minutes. Validation: term must be IN_PROGRESS, must have endDatetime set, and extensionMinutes must not exceed timeExtensionMinutes from test stage config. 
     * @summary Extend test term end time
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {ExtendTestTermTimeRequestDto} extendTestTermTimeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApiInterface
     */
    extendTestTermTime(certificationId: number, stageId: number, termId: number, extendTestTermTimeRequestDto: ExtendTestTermTimeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto>;

    /**
     * 
     * @summary Get test term detail
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApiInterface
     */
    getTestTermDetail(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto>;

    /**
     * Returns all test terms for the specified certification stage (type TEST). 
     * @summary List test terms for a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApiInterface
     */
    getTestTerms(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestTermListResponseDto>;

    /**
     * Marks the term as having results revealed to participants. After this call, candidates see the full test results (for RESULT_WITH_QUESTIONS visibility: questions with correct answers, optionally for a configured window of minutes). Requires the term to be in COMPLETED status. 
     * @summary Reveal answers/results to participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApiInterface
     */
    revealTestTermAnswers(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<RevealTestTermAnswersResponseDto>;

    /**
     * Updates test term properties. All fields are optional. Status transitions: NEW -> IN_PROGRESS -> COMPLETED / CANCELLED, CANCELLED -> NEW. Reverting from CANCELLED to NEW does NOT re-add participants that were expired during the cancellation — the admin must re-assign them. 
     * @summary Update test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {UpdateTestTermRequestDto} updateTestTermRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApiInterface
     */
    updateTestTerm(certificationId: number, stageId: number, termId: number, updateTestTermRequestDto: UpdateTestTermRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestTermDetailDto>;

}

/**
 * TestTermApi - object-oriented interface
 * @export
 * @class TestTermApi
 * @extends {BaseAPI}
 */
export class TestTermApi extends BaseAPI implements TestTermApiInterface {
    /**
     * Creates a new test term within a certification stage of type TEST. Initial status is NEW. 
     * @summary Create a new test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {CreateTestTermRequestDto} createTestTermRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApi
     */
    public createTestTerm(certificationId: number, stageId: number, createTestTermRequestDto: CreateTestTermRequestDto, options?: RawAxiosRequestConfig) {
        return TestTermApiFp(this.configuration).createTestTerm(certificationId, stageId, createTestTermRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extends the end datetime of an active test term by the specified number of minutes. Validation: term must be IN_PROGRESS, must have endDatetime set, and extensionMinutes must not exceed timeExtensionMinutes from test stage config. 
     * @summary Extend test term end time
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {ExtendTestTermTimeRequestDto} extendTestTermTimeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApi
     */
    public extendTestTermTime(certificationId: number, stageId: number, termId: number, extendTestTermTimeRequestDto: ExtendTestTermTimeRequestDto, options?: RawAxiosRequestConfig) {
        return TestTermApiFp(this.configuration).extendTestTermTime(certificationId, stageId, termId, extendTestTermTimeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get test term detail
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApi
     */
    public getTestTermDetail(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestTermApiFp(this.configuration).getTestTermDetail(certificationId, stageId, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all test terms for the specified certification stage (type TEST). 
     * @summary List test terms for a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApi
     */
    public getTestTerms(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return TestTermApiFp(this.configuration).getTestTerms(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks the term as having results revealed to participants. After this call, candidates see the full test results (for RESULT_WITH_QUESTIONS visibility: questions with correct answers, optionally for a configured window of minutes). Requires the term to be in COMPLETED status. 
     * @summary Reveal answers/results to participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApi
     */
    public revealTestTermAnswers(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestTermApiFp(this.configuration).revealTestTermAnswers(certificationId, stageId, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates test term properties. All fields are optional. Status transitions: NEW -> IN_PROGRESS -> COMPLETED / CANCELLED, CANCELLED -> NEW. Reverting from CANCELLED to NEW does NOT re-add participants that were expired during the cancellation — the admin must re-assign them. 
     * @summary Update test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {UpdateTestTermRequestDto} updateTestTermRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermApi
     */
    public updateTestTerm(certificationId: number, stageId: number, termId: number, updateTestTermRequestDto: UpdateTestTermRequestDto, options?: RawAxiosRequestConfig) {
        return TestTermApiFp(this.configuration).updateTestTerm(certificationId, stageId, termId, updateTestTermRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

